import { render, staticRenderFns } from "./pendingUser.vue?vue&type=template&id=308081a4"
import script from "./pendingUser.vue?vue&type=script&lang=js"
export * from "./pendingUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports